import { gql } from "@apollo/client";

export const GET_ACCOUNTING_FIRM_LOGO_AND_SETTINGS = gql`
  query GetAccountingFirmLogoAndSettings($id: ID!) {
    getAccountingFirmSettings(id: $id) {
      domains
    }
    getAccountingFirm(id: $id) {
      logo
      name
    }
  }
`;

export const LIST_ACCOUNTING_FIRMS_QUERY = gql`
  query listAccountingFirmsPaginated($limit: Int, $offset: Int, $filter: AccountingFirmFilter) {
    listAccountingFirmsPaginated(filter: $filter) {
      results(limit: $limit, offset: $offset, orderBy: "name") {
        id
        name
        companies {
          id
          name
          internalReference
        }
      }
      totalCount
    }
  }
`;

export const LIST_ACCOUNTING_FIRM_PAGINATED = gql`
  query ($filter: AccountingFirmFilter, $limit: Int, $offset: Int, $orderBy: [String]) {
    listAccountingFirmsPaginated(filter: $filter) {
      totalCount
      results(limit: $limit, offset: $offset, orderBy: $orderBy) {
        id
        name
        companies {
          id
          name
          internalReference
        }
      }
    }
  }
`;
